<template>
  <div class="content-img" :style="getbackground">
    <PlayIcon />
    <div v-if="showProgressBar" class="content-img__progress">
      <div
        class="content-img__progress__completed"
        :style="`width: ${progress}%`"
      ></div>
    </div>
  </div>
</template>

<script>
import { PlayIcon } from 'vue-feather-icons'
import CONSTANTS from '@/constants'

export default {
  name: 'ContentImg',
  components: {
    PlayIcon,
  },
  props: {
    content: {
      type: Object,
      required: true,
    },
    hasAccess: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    progress() {
      const { content_type, user_status } = this.content
      const { CONTENT_USER_STATUS } = CONSTANTS
      const { is_trackable } = this.content
      if (content_type && content_type === 'course') {
        if (this.hasAccess) return user_status.progress * 100
        return 0
      }

      switch (user_status) {
        case CONTENT_USER_STATUS.UNSTARTED:
          return 0
        case CONTENT_USER_STATUS.STARTED: {
          return is_trackable ? 50 : 100
        }
        case CONTENT_USER_STATUS.FINISHED:
        case CONTENT_USER_STATUS.VISITED:
          return 100
        default:
          return 0
      }
    },
    getbackground() {
      const { uuid, content_type } = this.content

      switch (content_type) {
        case 'course':
          return this.images?.small_image_url
            ? `background-image: url(${this.content.images.small_image_url})`
            : `background-image: url(${this.$getCourseBackground(
                uuid,
                'small'
              )}), linear-gradient(${this.$getGradient()})`
        case 'lab':
          return `background-image: linear-gradient(${this.$getGradient()})`
        default:
          return `background: linear-gradient(${this.$getGradient()});`
      }
    },
    showProgressBar() {
      return this.hasAccess && this.content && (this.content.has_trackable_content || this.content.is_trackable)
    },
  },
}
</script>

<style lang="scss" scoped>
.content-img {
  display: flex;
  position: relative;
  flex-flow: row wrap;
  justify-content: center;
  align-items: center;
  width: 110px;
  height: 127px;
  background-size: cover;
  padding: 10px 12px;

  @include mobile {
    width: 133px;
    height: 106px;
  }

  &__progress {
    position: absolute;
    display: flex;
    align-items: center;
    background-color: rgba(255, 255, 255, 0.25);
    border-radius: 10px;
    height: 5px;
    width: 80%;
    align-self: flex-end;

    &__completed {
      height: inherit;
      border-radius: inherit;
      background-color: var(--white);
    }
  }
}
</style>
